import type React from 'react';
import { LoadingMask } from '@zillow/constellation';
import { ZDocsEditor } from '@zillow/zdocs-web';

// Loading Mask

type LoadingMaskProps = React.ComponentProps<typeof LoadingMask>;
type ZDocsEditorProps = React.ComponentProps<typeof ZDocsEditor>;

export function StyledLoadingMask(props: LoadingMaskProps) {
  return <LoadingMask {...props} style={{ display: 'block', minHeight: '3rem', ...props.style }} />;
}

export function FullHeightLoadingMask(props: LoadingMaskProps) {
  return <LoadingMask {...props} style={{ display: 'block', height: '100%', ...props.style }} />;
}

export function StyledZDocsEditor(props: ZDocsEditorProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <ZDocsEditor {...(props as any)} style={{ display: 'block', ...(props as any).style }} />;
}

export function ModalBodyFullHeightLoadingMask(props: LoadingMaskProps) {
  return <LoadingMask {...props} style={{ display: 'block', height: 'calc(100% - 2rem)', ...props.style }} />;
}

// Durations

export const CSS_TRANSITION_DURATION = 500; // We are speed
